import { useEffect, useState } from "react";
import { WifiOff } from "lucide-react";
import { useTranslation } from "@/hooks/useTranslation";

/** Slim cross-cutting strip when `navigator.onLine` is false — no new recovery logic. */
export function OfflineBanner() {
  const { tDynamic } = useTranslation();
  const [online, setOnline] = useState(
    () => typeof navigator !== "undefined" && navigator.onLine
  );

  useEffect(() => {
    const on = () => setOnline(true);
    const off = () => setOnline(false);
    window.addEventListener("online", on);
    window.addEventListener("offline", off);
    return () => {
      window.removeEventListener("online", on);
      window.removeEventListener("offline", off);
    };
  }, []);

  if (online) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      className="flex items-center justify-center gap-2 border-b border-border bg-muted/90 px-3 py-2 text-center text-sm text-foreground"
    >
      <WifiOff className="h-4 w-4 shrink-0 text-muted-foreground" aria-hidden />
      <span>{tDynamic("You're offline. Reconnect to sync.")}</span>
    </div>
  );
}
